import type { Order } from "~/modules/project/api/order/orderTypes.ts";

// The part of the effective order budget that comes from quota slices with the top-up flag (ADR 0009).
// The backend keeps budgetCentsEffective as the order's own budget plus these slices.
export function getOrderQuotaTopUpCents(order: Pick<Order, "budgetCents" | "budgetCentsEffective">): number {
	return order.budgetCentsEffective - order.budgetCents;
}
